import { render } from "./PBXCallQueue.vue?vue&type=template&id=2b917639"
import script from "./PBXCallQueue.vue?vue&type=script&lang=js"
export * from "./PBXCallQueue.vue?vue&type=script&lang=js"

import "./PBXCallQueue.vue?vue&type=style&index=0&id=2b917639&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__